import Migas from './migas';
import { SIZE } from './constants';

export default Migas;
export { SIZE };